import { render, staticRenderFns } from "./classHonor.vue?vue&type=template&id=742c0b0a&"
import script from "./classHonor.vue?vue&type=script&lang=js&"
export * from "./classHonor.vue?vue&type=script&lang=js&"
import style0 from "./classHonor.vue?vue&type=style&index=0&id=742c0b0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports